import { orchestrator } from 'satcheljs';
import { resetFullCompose } from 'owa-calendar-compose-form-actions';
import EventScope from 'owa-service/lib/contract/EventScope';
import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';

export default orchestrator(resetFullCompose, actionMessage => {
    lazyShowFullComposeInEditMode.importAndExecute(
        actionMessage.event,
        EventScope.Default,
        false /* itemHasUpdates */,
        'FullCompose_Reset',
        actionMessage.viewType,
        null /* extractionSourceId */
    );
});
